import React, {useState} from 'react';
import PropTypes from 'prop-types';
import t from "../../../languages/pl";
import { isEmail } from './../../../utils/helpers';
import TextField from '@material-ui/core/TextField';

const EmailTextField = props => {
    const { value, onChange, className, isRequired, name } = props;
    const [badEmail, setBadEmail] = useState("" );

    const validateEmail = e => {
        if (!isEmail(e.target.value) && e.target.value !== "")
            setBadEmail(t.incorrectEmailFormat);
        else setBadEmail("");
    };

    const handleEmailChange = e => {
        if (badEmail !== "" && isEmail(e.target.value))
            setBadEmail(null);
        onChange && onChange(e);
    };

    return (
        <React.Fragment>
            <TextField
                    label={t.emailAddressLabel}
                    className={className}
                    error={badEmail !== ""}
                    helperText={badEmail}
                    type="email"
                    name={name ? name : "email"}
                    required={isRequired}
                    value={value}
                    onChange={handleEmailChange}
                    onBlur={validateEmail}
                />
        </React.Fragment>
    );
};

EmailTextField.propTypes = {
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    value: PropTypes.string,
    onChange: PropTypes.func,
    isRequired: PropTypes.bool,
    name: PropTypes.string,
};

export default EmailTextField;
